export const OFFICIAL_LIVE_CALLBACK_PROVIDER_STATE = 'officialLiveCallbackProvider';
